import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbImage } from "abreact/misc/AbImage";
import { AbSize, AbSizeContext } from "abreact/misc/AbSize";
import { ElementUtils } from "abweb/utils/ElementUtils";
import * as React from "react";
const sizeToPixelSize = (size, element) => {
  switch (size) {
    case AbSize.EXTRA_SMALL:
    case AbSize.SMALL:
    case AbSize.MEDIUM:
    case undefined:
    case AbSize.LARGE:
    case AbSize.EXTRA_LARGE:
      return ElementUtils.getCssAsNumber("--ab-size-default-icon-size", NaN, element);
    case AbSize.CUSTOM:
      return NaN;
  }
};
export function AbIcon(props) {
  const {
    className,
    size,
    ...rest
  } = props;
  const imageRef = React.useRef(null);
  const context = React.useContext(AbSizeContext);
  const sizeWithContext = size ?? context;
  const [iconSize, setIconSize] = React.useState(() => sizeToPixelSize(sizeWithContext, undefined));
  React.useEffect(() => {
    setIconSize(sizeToPixelSize(sizeWithContext, imageRef.current ?? undefined));
  }, [sizeWithContext]);
  const sizeToPass = isNaN(iconSize) ? undefined : iconSize;
  return /*#__PURE__*/React.createElement(AbImage, _extends({}, rest, {
    className: ReactUtils.classNamesString(["ab-icon", className, sizeWithContext]),
    width: sizeToPass,
    height: sizeToPass,
    ref: imageRef
  }));
}
//# sourceMappingURL=AbIcon.js.map
